import { cx } from '@emotion/css';
import { FC, PropsWithChildren } from 'react';

interface OverviewSubsectionProps {
  headline?: string;
  subHeadline?: string;
  className?: string;
  dataTestId: string;
}

export const OverviewSubsection: FC<PropsWithChildren<OverviewSubsectionProps>> = ({
  headline,
  subHeadline,
  className,
  children,
  dataTestId,
}) => (
  <section aria-label={headline} className={cx('mt-12 select-none hover:select-text desktop:mt-16', className)} data-testid={dataTestId}>
    {headline && <h3 className="stihl-text-h3-desktop">{headline}</h3>}
    {subHeadline && <p className="mt-2 max-w-2xl stihl-text-body-default-reg">{subHeadline}</p>}
    {children}
  </section>
);
